import React from 'react';
import styled from 'styled-components';

const PolicyContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  color: ${({ theme }) => theme.text};
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 1.5rem;
  color: ${({ theme }) => theme.textStrong};
`;

const CompanyInfo = styled.div`
  margin-bottom: 2rem;
  padding: 1.5rem;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  
  p {
    margin-bottom: 0.5rem;
  }
`;

const Content = styled.div`
  font-size: 1rem;
  line-height: 1.7;

  h2 {
    font-size: 1.5rem;
    margin: 1.5rem 0 1rem;
    color: ${({ theme }) => theme.textStrong};
  }

  p {
    margin-bottom: 1rem;
  }

  ul {
    margin-bottom: 1rem;
    padding-left: 1.5rem;
  }

  li {
    margin-bottom: 0.5rem;
  }
  
  a {
    color: var(--primary);
    text-decoration: none;
    position: relative;
    
    &:after {
      content: '';
      position: absolute;
      width: 0;
      height: 1px;
      bottom: -1px;
      left: 0;
      background-color: var(--primary);
      transition: width 0.3s ease;
    }
    
    &:hover {
      &:after {
        width: 100%;
      }
    }
  }
`;

const Section = styled.div`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: ${({ theme }) => theme.textStrong};
`;

const TermsOfService = () => {
  return (
    <PolicyContainer>
      <Title>Terms & Conditions</Title>
      
      <Content>
        <Section>
          <SectionTitle>1. General</SectionTitle>
          <p>
            These Terms & Conditions ("Terms") govern the use of the mobile application 1cal: AI Food Calorie Counter
            ("Application"), provided by Mystream Limited ("Service Provider").
          </p>
        </Section>
        
        <Section>
          <SectionTitle>2. Company Information</SectionTitle>
          <CompanyInfo>
            <p><strong>Mystream Limited</strong></p>
            <p><strong>Registration Number:</strong> HE423185</p>
            <p><strong>Registered Address:</strong> Spirou Kyprianou, 78 MAGNUM BUSINESS CENTER, 3rd floor, 3076, Limassol, Cyprus</p>
            <p><strong>Email:</strong> <a href="mailto:support@1cal.ai">support@1cal.ai</a></p>
            <p><strong>Website:</strong> <a href="https://1cal.ai" target="_blank" rel="noopener noreferrer">https://1cal.ai</a></p>
          </CompanyInfo>
        </Section>
        
        <Section>
          <SectionTitle>3. Acceptance of Terms</SectionTitle>
          <p>
            By downloading or using the Application, you agree to comply with these Terms. If you do not agree with any
            part of the Terms, you should not use the Application.
          </p>
        </Section>
        
        <Section>
          <SectionTitle>4. Intellectual Property</SectionTitle>
          <p>
            All rights, title, and interest in and to the Application, including but not limited to copyrights, trademarks, and
            other intellectual property rights, remain with the Service Provider. You may not copy, modify, distribute, or
            use any part of the Application without written permission.
          </p>
        </Section>
        
        <Section>
          <SectionTitle>5. Use of the Application</SectionTitle>
          <p>
            You agree to use the Application only for lawful purposes and in accordance with these Terms.
          </p>
        </Section>
        
        <Section>
          <SectionTitle>6. Personal Data and GDPR Compliance</SectionTitle>
          <p>
            The Application collects and processes personal data in accordance with our Privacy Policy. Under the
            GDPR, users have the right to:
          </p>
          <ul>
            <li>Access their personal data</li>
            <li>Correct inaccurate or incomplete data</li>
            <li>Request deletion of their data</li>
            <li>Restrict processing of their data</li>
            <li>Request data portability</li>
            <li>Object to processing of their data</li>
          </ul>
          <p>
            To exercise your rights, contact us at <a href="mailto:support@1cal.ai">support@1cal.ai</a>.
          </p>
        </Section>
        
        <Section>
          <SectionTitle>7. Third-Party Services</SectionTitle>
          <p>
            The Application may include links to third-party services:
          </p>
          <ul>
            <li>Google Play Services</li>
            <li>Amplitude</li>
            <li>Adapty</li>
          </ul>
          <p>
            We are not responsible for the content or privacy practices of these third-party services.
          </p>
        </Section>
        
        <Section>
          <SectionTitle>8. Limitation of Liability</SectionTitle>
          <p>
            The Application is provided "as is" without warranties. The Service Provider is not liable for any losses or
            damages arising from the use or inability to use the Application.
          </p>
        </Section>
        
        <Section>
          <SectionTitle>9. Changes to the Terms</SectionTitle>
          <p>
            We reserve the right to update these Terms at any time. Updates will be posted within the Application or on
            our website.
          </p>
        </Section>
        
        <Section>
          <SectionTitle>10. Contact</SectionTitle>
          <p>
            If you have questions about these Terms, contact us at: <a href="mailto:support@1cal.ai">support@1cal.ai</a>
          </p>
        </Section>
        
        <Section>
          <SectionTitle>11. Related Policies</SectionTitle>
          <p>
            The following documents form an integral part of these Terms & Conditions and are hereby incorporated by
            reference:
          </p>
          <ul>
            <li>Privacy Policy: <a href="/privacy">https://1cal.ai/privacy</a></li>
            <li>Refund Policy: <a href="/refund">https://1cal.ai/refund</a></li>
            <li>Subscription Terms: <a href="/subscription">https://1cal.ai/subscription</a></li>
          </ul>
        </Section>
      </Content>
    </PolicyContainer>
  );
};

export default TermsOfService; 